/**
 * Collection cards (card-collection.liquid): the trailing arrow should
 * always land right after the name -- alone on its own line 2 when the
 * name only needs 1 line, or next to the name's last word when the name
 * needs 2 -- and the name itself is never cut off, and the pair never
 * spills onto a 3rd line. Which layout applies depends on how many lines
 * the name wraps to, which CSS alone can't detect, so this measures each
 * card after layout and:
 * - marks single-line names with .card__heading--icon-own-line, which
 *   gx-global.css uses to force the arrow onto its own fresh line;
 * - for two-line names, shrinks the heading's font-size a little (in
 *   small steps, down to a floor) if that's the only way to keep the
 *   arrow on the name's own 2nd line instead of wrapping to a 3rd;
 * - hides the arrow as a last resort on the rare card where even the
 *   smallest allowed size still doesn't leave room for it.
 */
function fitCardHeading(heading) {
  const textEl = heading.querySelector('.card__heading-text');
  const iconWrap = heading.querySelector('.icon-wrap');
  if (!textEl || !iconWrap) return;

  heading.classList.remove('card__heading--icon-own-line');
  heading.style.fontSize = '';
  iconWrap.hidden = false;

  // .card__heading-text is inline (has to be, so the arrow can flow right
  // after it on the same line) -- scrollHeight isn't reliable on inline
  // elements for detecting wrapped lines, but getClientRects() returns one
  // rect per line box, which is exactly what wrapped inline content needs.
  const textIsSingleLine = textEl.getClientRects().length <= 1;

  if (textIsSingleLine) {
    heading.classList.add('card__heading--icon-own-line');
    return;
  }

  const originalFontSize = parseFloat(getComputedStyle(heading).fontSize);
  const minFontSize = originalFontSize - 4;
  let fontSize = originalFontSize;
  let lineHeight = parseFloat(getComputedStyle(textEl).lineHeight) || textEl.clientHeight;
  let guard = 0;

  while (heading.scrollHeight > lineHeight * 2 + 1 && fontSize > minFontSize && guard < 6) {
    fontSize -= 1;
    heading.style.fontSize = `${fontSize}px`;
    lineHeight = parseFloat(getComputedStyle(textEl).lineHeight) || lineHeight;
    guard += 1;
  }

  if (heading.scrollHeight > lineHeight * 2 + 1) {
    iconWrap.hidden = true;
  }
}

function runFitCardHeadings() {
  document.querySelectorAll('.card__heading').forEach((heading) => {
    if (heading.querySelector('.card__heading-text')) fitCardHeading(heading);
  });
}

if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(runFitCardHeadings);
} else {
  runFitCardHeadings();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runFitCardHeadings);
} else {
  runFitCardHeadings();
}

let cardHeadingResizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(cardHeadingResizeTimeout);
  cardHeadingResizeTimeout = setTimeout(runFitCardHeadings, 150);
});
